module.exports = __webpack_public_path__ + "static/media/send-icon.e29d2c96.svg";